import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { CLIENT_ID, applyTheme, useStore } from './store'
import './styles/app.css'
import { Capacitor } from '@capacitor/core'

// Dev-only handle for poking at state from the console.
if (import.meta.env.DEV) {
  const w = window as unknown as Record<string, unknown>
  w.__store = useStore
  w.__clientId = CLIENT_ID
}

// The Electron preload marks the window so CSS can inset for traffic lights.
if (navigator.platform.startsWith('Mac') && 'electronShell' in window) {
  document.body.classList.add('is-mac-desktop')
}

// Apply before first paint so a pinned theme never flashes the wrong one.
applyTheme(useStore.getState().theme)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Android and iOS draw under the status bar at every width. The safe-area
// padding used to live only in the narrow media query, so an unfolded foldable
// — wide enough for the three-pane layout — ran its toolbars under the system
// bar.
if (Capacitor.isNativePlatform()) document.body.classList.add('is-native')
